import UserSettingsPage from '@/views/UserSettings.vue';

export default class IdentityRoutes {
  public static Routes = [
    {
      path: 'settings',
      name: 'identity-user',
      component: UserSettingsPage,
      meta: {
        label: 'User settings',
      },
    },
  ];
}
